/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { TreeNode } from './tree-node';
import { BehaviorSubject, Subscription } from 'rxjs';

export class FileColumn {
  get data(): TreeNode[] {
    return this._data;
  }

  set data(value: TreeNode[]) {
    this._data = value;
    this.displayedData = value;
  }

  public id: string;
  public label: string;
  public node: TreeNode;
  public displayedData: TreeNode[];
  public selectedNode: TreeNode;
  public isCollapsed = false;

  private _data: TreeNode[];
  private _collapse: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(id: string, label: string, node: TreeNode, filter: boolean) {
    this.id = id;
    this.label = label;
    this.node = node;
    if (filter) {
      this.data = !!node && node.filteredNodes ? node.filteredNodes : [];
    } else {
      this.data = !!node && node.nodes ? node.nodes : [];
    }
  }

  public search(value: string): void {
    if (value) {
      const search = value.toLowerCase();
      const temp = [];
      for (const d of this._data) {
        if (d.toString().toLowerCase().indexOf(search) >= 0 ) {
          temp.push(d);
        }
      }
      this.displayedData = temp;
    } else {
      this.displayedData = this._data;
    }
  }

  public refresh(): void {
    this.data = !!this.node && this.node.nodes ? this.node.nodes : [];
  }

  public sort(indice: 1| -1): void {
    this.data.sort( (a, b) => {
      return a.toString().localeCompare(b.toString()) * indice;
    });
  }

  public collapse(collapse: boolean): void {
    this.isCollapsed = collapse;
    this._collapse.next(collapse);
  }

  public subscribeCollapse(next: (collapse: boolean) => void, error?: (error) => void): Subscription {
    return this._collapse.subscribe({ next, error });
  }
}
